import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Form } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import { Layout, Row, Col, Card } from 'antd';
import PaginatedReduxTable from '../paginated_redux_table/PaginatedReduxTable';
import { metersRestCrudThunksForSupplier } from '../../thunks/meters_thunks';
import { EmptyState } from '../empty_state/EmptyState';
import { locationsRestCrudThunksForSupplier } from '../../thunks/locations_thunks';
import {
	fetchSupplierFacilitiesInPrivateNetworkForSupplier,
	supplierFacilitiesRestCrudThunksForSupplier,
} from '../../thunks/supplier_facilities_thunks';
import LogOnMountWithStandardEventProperties from '../log_on_mount_with_standard_event_properties/LogOnMountWithStandardEventProperties';
import SubnavBar from '../subnav_bar/SubnavBar';
import { AdvancedFilters } from '../advanced_filters/AdvancedFilters';
import {
	nullSafeGet,
	nullSafeGetOrElse,
	changeFilterValueToArrayOfIds,
} from '../../utils/DataAccessUtils';
import RegionsLocationsTreeSelect from '../regions_tree_select/SupplierRegionsLocationsTreeSelect';
import { meterTypesRestCrudThunksForSupplier } from '../../thunks/meter_types_thunks';
import { METERS_CRUD_ACTION_CREATORS } from '../../actions/meters_actions';
import OWAsyncTreeSelect from '../ow_async_tree_select/OWAsyncTreeSelect';

const { Content } = Layout;

const queryString = require('qs');
require('./SupplierMetersIndexPage.less');

const METERS_OVERVIEW_TARGET_COLLECTION = 'metersIndex';

class SupplierMetersIndexPage extends React.Component<any, any> {
	initialPagination: any = { current: 1, pageSize: 10 };
	initialFilters: any;

	constructor(props) {
		super(props);
		const { updateMetersFilters, location } = props;
		let searchString = location.search;
		if (searchString[0] === '?') {
			searchString = searchString.slice(1);
		}
		const queryParams = queryString.parse(searchString);
		const { current, pageSize, total, sort_by, order, ...meterFilters } = queryParams;
		this.initialPagination = { current: current ? current : 1, pageSize: pageSize ? pageSize : 10 };
		this.initialFilters = meterFilters && Object.keys(meterFilters).length > 0 ? meterFilters : {};
		updateMetersFilters(this.initialFilters, METERS_OVERVIEW_TARGET_COLLECTION);
	}

	render() {
		const {
			history,
			locations,
			meters,
			meterTypes,
			fetchMultipleLocations,
			fetchLocations,
			location,
			fetchMultipleMeterTypes,
			fetchMeterTypes,
			updateMetersFilters,
			clearAndUpdateFilters,
		} = this.props;

		const onRow = (record) => ({
			onClick: () => {
				let searchString = location.search;
				if (searchString[0] === '?') {
					searchString = searchString.slice(1);
				}
				let backUrl = `/supplier/meters/detail/${record.id}/details`;
				if (searchString && searchString.length > 0) {
					backUrl = backUrl.concat(`?backlinkParams=${encodeURIComponent(searchString)}`);
				}
				history.push(backUrl);
			},
		});

		const columns = [
			{
				title: 'Location',
				dataIndex: ['location', 'name'],
				sorter: true,
			},
			{
				title: 'Asset',
				dataIndex: ['asset', 'name'],
				sorter: true,
			},
			{
				title: 'Meter Name',
				dataIndex: 'name',
				sorter: true,
			},
		];

		return (
			<Content className="metersIndexPage" style={{ padding: '0 0.5em' }}>
				<LogOnMountWithStandardEventProperties eventType="visited supplier meters index page" />
				{/*<ScrollToTopOnMount/>*/}
				{/*<BackTop/>*/}
				<Row style={{ margin: '0.5em -8px' }}>
					<Col span={24}>
						<SubnavBar
							left={
								<div>
									<AdvancedFilters
										initialFilters={this.initialFilters}
										updateFilters={updateMetersFilters}
										filterConfig={[
											{
												label: 'Location',
												stateSlice: locations,
												hideFilter: true,
												filtersValueAccessor: (filtersStateSlice) => {
													const locationIds = nullSafeGet(
														`${METERS_OVERVIEW_TARGET_COLLECTION}.filters.locationIds`,
														filtersStateSlice
													);
													const finalIds = nullSafeGetOrElse(
														`${METERS_OVERVIEW_TARGET_COLLECTION}.filters.regionIds`,
														filtersStateSlice,
														locationIds
													);
													return changeFilterValueToArrayOfIds(finalIds);
												},
												keyAccessor: (loc) => loc.id,
												valueAccessor: (loc) => loc.id,
												handleChange: (ids) => {
													updateMetersFilters(
														{
															locationIds: ids.join(',') || undefined,
															regionIds: undefined,
														},
														METERS_OVERVIEW_TARGET_COLLECTION
													);
												},
												targetCollectionName: 'metersAdvancedFilters',
												fetch: fetchLocations,
												fetchMultiple: fetchMultipleLocations,
												renderItem: (loc) => loc.name,
												sortBy: { sort_by: 'name', order: 'ascend' },
											},
											{
												label: 'Meter Type',
												mode: 'multiple',
												stateSlice: meterTypes,
												filtersValueAccessor: (filtersStateSlice) => {
													const ids = nullSafeGet(
														`${METERS_OVERVIEW_TARGET_COLLECTION}.filters.meterTypeIds`,
														filtersStateSlice
													);
													return changeFilterValueToArrayOfIds(ids);
												},
												keyAccessor: (meterType) => meterType.id,
												valueAccessor: (meterType) => meterType.id,
												handleChange: (ids) => {
													updateMetersFilters(
														{
															meterTypeIds: ids.join(',') || undefined,
														},
														METERS_OVERVIEW_TARGET_COLLECTION
													);
												},
												targetCollectionName: 'metersAdvancedFilters',
												fetch: fetchMeterTypes,
												fetchMultiple: fetchMultipleMeterTypes,
												renderItem: (meterType) => meterType.name,
												sortBy: { sort_by: 'name', order: 'ascend' },
												component: OWAsyncTreeSelect,
											},
										]}
										filtersTargetCollectionName={METERS_OVERVIEW_TARGET_COLLECTION}
										clearAndUpdateFilters={clearAndUpdateFilters}
										filtersStateSlice={meters}
									>
										<Form.Item label="Location">
											<RegionsLocationsTreeSelect
												mode="multiple"
												filtersSlice={meters}
												filtersValueAccessor={(filtersStateSlice) => {
													const locationIds = nullSafeGet(
														`${METERS_OVERVIEW_TARGET_COLLECTION}.filters.locationIds`,
														filtersStateSlice
													);
													const finalIds = nullSafeGetOrElse(
														`${METERS_OVERVIEW_TARGET_COLLECTION}.filters.regionIds`,
														filtersStateSlice,
														locationIds
													);
													return changeFilterValueToArrayOfIds(finalIds);
												}}
												onChange={(ids) => {
													updateMetersFilters(
														{
															locationIds: ids.join(',') || undefined,
															regionIds: undefined,
														},
														METERS_OVERVIEW_TARGET_COLLECTION
													);
												}}
												targetCollectionName={'metersAdvancedFilters'}
											/>
										</Form.Item>
									</AdvancedFilters>
								</div>
							}
							right={<div></div>}
						/>
					</Col>
				</Row>
				<Row style={{ margin: '0.5em -8px' }}>
					<Col span={24}>
						<Card bodyStyle={{ padding: 8 }}>
							<PaginatedReduxTable
								updateQueryParams={true}
								emptyState={
									<EmptyState
										graphic={
											<img
												style={{ marginBottom: 8 }}
												src="https://s3.amazonaws.com/mock-data-assets/categories/images/cactus.svg"
												alt="You haven't created any meters yet."
											/>
										}
										headline={"You haven't created any meters yet."}
										body={
											<div style={{ textAlign: 'center' }}>
												<div style={{ maxWidth: 440, marginBottom: 16 }}></div>
											</div>
										}
									/>
								}
								collectionName="meters"
								onRow={onRow}
								showHeader={true}
								targetCollectionName={METERS_OVERVIEW_TARGET_COLLECTION}
								columns={columns}
								keyAccessor={(el) => el.id}
								initialFilters={this.initialFilters}
								initialPagination={this.initialPagination}
								fetchData={metersRestCrudThunksForSupplier.read}
							/>
						</Card>
					</Col>
				</Row>
			</Content>
		);
	}
}

const mapStateToProps = (state, ownProps) => ({
	history: ownProps.history,

	currentUser: state.session.currentUser,
	meters: state.meters,
	meterTypes: state.meter_types,
	locations: state.locations,
	regions: state.regions,
	supplierFacilities: state.supplier_facilities,
});

const mapDispatchToProps = (dispatch) => ({
	updateMetersFilters: (filters, targetCollection) =>
		dispatch(METERS_CRUD_ACTION_CREATORS.updateFilters(filters, targetCollection)),
	clearAndUpdateFilters: (filters, targetCollectionName) =>
		dispatch(METERS_CRUD_ACTION_CREATORS.clearAndUpdateFilters(filters, targetCollectionName)),
	fetchMultipleLocations: (ids, targetCollectionName) =>
		dispatch(locationsRestCrudThunksForSupplier.readMultiple(ids, targetCollectionName)),
	fetchLocations: (
		params,
		targetCollectionName,
		pagination,
		sorting,
		filters,
		addToTargetCollection
	) =>
		dispatch(
			locationsRestCrudThunksForSupplier.readLite(
				params,
				targetCollectionName,
				pagination,
				sorting,
				filters,
				addToTargetCollection
			)
		),
	fetchMultipleMeterTypes: (ids, targetCollectionName) =>
		dispatch(meterTypesRestCrudThunksForSupplier.readMultiple(ids, targetCollectionName)),
	fetchMeterTypes: (
		params,
		targetCollectionName,
		pagination,
		sorting,
		filters,
		addToTargetCollection
	) =>
		dispatch(
			meterTypesRestCrudThunksForSupplier.read(
				params,
				targetCollectionName,
				pagination,
				sorting,
				filters,
				addToTargetCollection
			)
		),
	fetchSupplierFacilitiesInPrivateNetwork: (
		params,
		targetCollectionName,
		pagination,
		sorting,
		filters,
		addToTargetCollection
	) =>
		dispatch(
			fetchSupplierFacilitiesInPrivateNetworkForSupplier(
				params,
				targetCollectionName,
				pagination,
				sorting,
				filters,
				addToTargetCollection
			)
		),
	fetchMultipleSupplierFacilities: (ids, targetCollectionName) =>
		dispatch(supplierFacilitiesRestCrudThunksForSupplier.readMultiple(ids, targetCollectionName)),
});

export default withRouter<any, any>(
	connect(mapStateToProps, mapDispatchToProps)(SupplierMetersIndexPage)
);
